import React from 'react';
import util from "../../util/tools";
import LoadMore from "../common/LoadMore";
import Header from "../common/Header";
import './index.css';

export default class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            curTitle: "我的红包",
            isLoad:false,
            hongbao:0,
            page: 1,
            data:[]
        };
    }

    componentDidMount() {
        document.title = this.state.curTitle;

        this.getUserInfo()
        this.result()
    }

    getUserInfo(){
        util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    this.setState({
                        hongbao:data.user_money.hongbao
                    })
                }
            }
        });
    }

    result(){
        let num = 10;
        util.ajax({
            url: "/zh/send/lists",
            isUser: true,
            isWechatId: true,
            data: {
                'page':this.state.page,
                '__flush_cache':1,
                'num':num
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    let tempData = {
                        data:this.state.data.concat(data),
                        page: parseInt(this.state.page) + 1,
                        isLoad: false
                    };
                    if(data.length == num){
                        // 还未到最后一页
                        tempData.isLoad = true;
                    }
                    this.setState(tempData)
                }
            }
        });
    }

    goRoute(){
        this.props.history.push('/recharge')
    }

    render() {
        return (
            <div className='packet'>
                <Header />
                {/*有无红包*/}
                {this.state.data.length>0 ?
                    <div className='packet_have'>
                        <div className='packet_have_box'>
                            <span className='packet_have_num'>{this.state.hongbao}</span>
                            <span className='packet_have_font'>红包剩余</span>
                        </div>
                        <div className='packet_have_lists'>
                            <div className='packet_have_lists_single'>
                                <span className='packet_have_lists_single_time'>红包过期时间</span>
                            </div>

                            {
                                !!this.state.data && this.state.data.length>0 && this.state.data.map((item,index) => {
                                    return (
                                        <div className='packet_have_lists_single' key={`hb_${index}`}>
                                            <span className='packet_item'>{(item.expiretime).substring(5)}</span>
                                            <span className='packet_item_center'>+
                                                {parseInt(item.is_expire) == 0 && `${item.coin} `}
                                                {parseInt(item.is_expire) == 0 && item.used_coin>0 && `已用${item.used_coin}`}
                                                {parseInt(item.is_expire) == 1 && `${item.coin} 已过期`}
                                                {parseInt(item.is_expire) == 2 && `${item.coin} 已用${item.used_coin}`}
                                            </span>
                                            <span className='packet_item'>
                                                {parseInt(item.type) == 1 && '签到红包'}
                                                {parseInt(item.type) == 2 && '充值赠送红包'}5天
                                            </span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    :
                    <div className='packet_no'>
                        <img className='packet_no_pic' src={require('../../../common/images/packet_no.png')} alt=""/>
                        <span className='packet_no_tip1'>你还没有获得红包哦~</span>
                        <span className='packet_no_tip2' onClick={()=>this.goRoute()}>充值获取？</span>
                    </div>
                }
                {this.state.isLoad && <LoadMore loadMoreData={()=>this.result()}/>}
            </div>
        );
    }
}